import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-6 h-7",
  viewBox: "0 0 30 37"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M27.488 18.598c0-.9-.463-1.688-1.175-2.125L15 9.848 3.687 16.473A2.489 2.489 0 0 0 2.5 18.598v12.5c0 1.375 1.125 2.5 2.5 2.5h20c1.375 0 2.5-1.125 2.5-2.5l-.012-12.5Zm-2.5 0v.012L15 24.848l-10-6.25 10-5.85 9.988 5.85ZM5 21.523v9.575h20l-.012-9.537L15 27.797 5 21.523Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m16.475 20.27 6.977-6.976a2.096 2.096 0 0 0-2.965-2.965l-3.398 3.398V3.841a2.096 2.096 0 0 0-4.192 0v9.886L9.499 10.33a2.096 2.096 0 0 0-2.965 2.965l6.977 6.976a2.096 2.096 0 0 0 2.964 0Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }